import { FC } from 'react';

import { Button } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import HtmlContent from '@telialt/common-html-content/src';
import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';
import { Benefit } from '@telialt/models/src/EshopModel';
import { getProductImageData } from '@telialt/utils/src/eshopUtils';
import { useComponentId } from '@telialt/utils/src/hooks';

import { useGiftDetailsModalControls } from '../../../GiftDetailsModal/useGiftDetailsModalControls';
import { useSpecialOfferGiftModalControls } from '../../useSpecialOfferModalControls';
import { GiftCellTitle, GiftDescription, GiftDescriptionCell, GiftImageCell } from './SpecialOfferModal.styles';

export const GiftCell: FC<Benefit> = (benefit) => {
    const { t } = useTranslations();
    const giftListModal = useSpecialOfferGiftModalControls();
    const giftDetailsModal = useGiftDetailsModalControls();

    const { gift } = benefit;
    const imageData = getProductImageData(gift.images, 'PRIMARY', 'product') || gift.images[0];
    const uid = 'gift-cell-title' + useComponentId();

    const openGiftDetailsModal = () => {
        giftDetailsModal.openModal([benefit, -2]);
        giftListModal.editModal(false);
    };

    return (
        <>
            <GiftImageCell src={imageData.url} alt={imageData.altText || gift.name} />
            <GiftDescriptionCell aria-labelledby={uid}>
                <GiftCellTitle id={uid} tag="h3" variant="title-100">
                    {gift.name}
                </GiftCellTitle>
                <HtmlContent baseComponent={GiftDescription} content={gift.description} />
                <Button onClick={openGiftDetailsModal} variant="text" data-test={ESHOP_TEST_ID.OPEN_GIFT_DETAILS_MODAL}>
                    {t['eshop.product_page.special_offers.open_gift_details']}
                </Button>
            </GiftDescriptionCell>
        </>
    );
};
